<template>
  <div class="center-loader">
    <Loader />
  </div>
</template>
<script>
import Loader from "@/components/widgets/loader";

export default {
  components: {
    Loader,
  },
};
</script>
<style scoped>
.center-loader {
  position: fixed;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  transform: -webkit-translate(-50%, -50%);
  transform: -moz-translate(-50%, -50%);
  transform: -ms-translate(-50%, -50%);
}
</style>